import { APICore } from "./apiCore";
const api = new APICore();

const exportTeamShiftAssignment = (params) => {
    const baseUrl = `team_shift/export_template`;
    return api.getFile(`${baseUrl}`, params)
};

const importTeamShiftAssignment = (params) => {
    const baseUrl = `team_shift/import_template`;
    return api.uploadExcel(`${baseUrl}`, params);
};

const getTeamShiftAssignmentList = (params) => {
    const baseUrl = `team_shift/list`;
    return api.get(`${baseUrl}`, params);
}

const getTeamShiftAssignmentListById = (id) => {
    const baseUrl = `team_shift/get?_id=${id}`;
    return api.get(`${baseUrl}`);
};

const addTeamShiftAssignment = (params) => {
    const baseUrl = `team_shift`;
    return api.create(`${baseUrl}`, params);
};

const updateTeamShiftAssignment = (params) => {
    const baseUrl = `team_shift/update`;
    return api.update(`${baseUrl}`, params);
};

const deleteTeamShiftAssignment = (id) => {
    const baseUrl = `team_shift/delete/${id}`;
    return api.delete(`${baseUrl}`);
};

export { exportTeamShiftAssignment, importTeamShiftAssignment, getTeamShiftAssignmentList, getTeamShiftAssignmentListById, addTeamShiftAssignment, updateTeamShiftAssignment, deleteTeamShiftAssignment }